if (!customElements.get("td-sticky-atc")) {
    class TDStickyATC extends HTMLElement {
        constructor() {
            super();
            this.STICKY_CLASS = 'sticky-atc-stuck';
            this.STICKY_COMPENSATE_CLASS = 'sticky-atc-compensate';
            this.STICKY_HIDE_CLASS = 'sticky-atc--hide';
            this.STICKY_ANIMATE_CLASS = 'sticky-atc--fade-out';
            this.COMPARE_AT_SELECTOR = '[data-product-price-compare]';
            this.PRICE_SELECTOR = '[data-product-price]';
            this.LOADING = false;

            this.mainButton = document.querySelector('.add-to-cart');
            this.stickyContainer = this.querySelector('.sticky-atc-wrapper');
            this.atcButton = this.querySelectorAll('.btn__add-to-cart');
            this.atcText = this.querySelectorAll('[data-atc-product-variant]');
            this.stickyClose = this.querySelector('[data-close-sticky]');
            this.buttonText = this.querySelector('.sticky-atc-text');
            this.stickyCheckmark = this.querySelector('.sticky-atc-checkmark ');
            this.stickyLoader = this.querySelector('.sticky-atc-loading');
            this.price = this.querySelector(this.PRICE_SELECTOR);
            this.compare_price = this.querySelector(this.COMPARE_AT_SELECTOR);
        }
    
        connectedCallback() {
            if (this.mainButton && this.stickyContainer) {
                const observer = new IntersectionObserver((entries) => {
                    if (!entries[0].isIntersecting) {
                        if (window.scrollY >= this.mainButton.offsetTop + this.mainButton.offsetHeight) {
                            this.stickyContainer.classList.add(this.STICKY_CLASS);
                        }
                    } else {
                        this.stickyContainer.classList.remove(this.STICKY_CLASS);
                    }
                });
                observer.observe(this.mainButton);
            }
        
            if (this.atcButton && this.atcText) {
                this.cartQuantity()

                document.addEventListener('variant:change', ({detail}) => this.updateUI(detail))
                document.addEventListener('ajaxProduct:added', () => {this.cartQuantity()})
        
                this.atcButton.forEach(btn => {
                    btn.addEventListener('click', () => {
                        var productID = btn.dataset.productId
                        this.LOADING = true;
                        if (this.LOADING) {
                            this.buttonText.classList.add(this.STICKY_HIDE_CLASS)
                            this.stickyLoader.classList.remove(this.STICKY_HIDE_CLASS)
                        }
                        this.addItemToCart({ id: productID, quantity: 1});
                    })
                });
            }

            if (this.stickyClose) {
                this.stickyClose.addEventListener('click', () => this.closeSticky())
            }
        }

        updateUI(detail) {
            this.atcText.forEach(text => {
                text.textContent = detail.variant.title
            })
            if (this.compare_price && detail.variant.compare_price) {
                if (detail.variant.compare_price > detail.variant.price) {
                    this.compare_price.textContent = theme.Currency.formatMoney(detail.variant.price, theme.settings.moneyFormat)
                } else {
                this.compare_price.textContent = ''
                }
            }
            if (this.price && detail.variant.price) {
                this.price.textContent = theme.Currency.formatMoney(detail.variant.price, theme.settings.moneyFormat)
            }
            this.atcButton.forEach(btn => {
                btn.dataset.productId = detail.variant.id
                if (detail.variant.available) {
                    btn.disabled = false;
                    btn.textContent = 'ADD TO CART'
                } else {
                    btn.disabled = true;
                    btn.textContent = 'SOLD OUT'
                }
            })
        }

        closeSticky() {
            this.remove();
        }

        moveATC(item_count) {
            if (item_count > 0) {
                this.stickyContainer.classList.add(this.STICKY_COMPENSATE_CLASS);
            } else {
                this.stickyContainer.classList.remove(this.STICKY_COMPENSATE_CLASS);
            }
        }

        async addItemToCart(product) {
            try {
                const response = await fetch(`${window.location.origin}/cart/add.js`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(product)
                });
        
                if (response.status === 200) {
                    const {item_count, items, total_price} = await response.json();
                    this.count = item_count;
                    this.items = items;
                    this._total = total_price;
                    document.dispatchEvent(new CustomEvent('ajaxProduct:added'))
                    this.LOADING = false;
                    if (!this.LOADING) {
                        this.stickyLoader.classList.add(this.STICKY_HIDE_CLASS)
                        this.stickyCheckmark.classList.remove(this.STICKY_HIDE_CLASS)
                        this.stickyCheckmark.classList.add(this.STICKY_ANIMATE_CLASS)
                        setTimeout(() => {
                            this.stickyCheckmark.classList.add(this.STICKY_HIDE_CLASS)
                            this.buttonText.classList.remove(this.STICKY_HIDE_CLASS)
                        }, 700);
                    }
                } 
            } catch (err) {
                console.log(err);
            }
        }

        // GET CART QUANTITY AJAX/LOGIC
        async cartQuantity() {
            try {
                const response = await fetch(`${window.location.origin}/cart/update.js`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }
                });
        
                if (response.status === 200) {
                    const {item_count} = await response.json();
                    if (item_count > 0) {
                        if (!this.stickyContainer.classList.contains(this.STICKY_COMPENSATE_CLASS)) {
                            this.stickyContainer.classList.add(this.STICKY_COMPENSATE_CLASS);
                        }
                    } else {
                        this.stickyContainer.classList.remove(this.STICKY_COMPENSATE_CLASS);
                    }
                }

            } catch (err) {
                console.log(err);
            }
        }
    }

    customElements.define("td-sticky-atc", TDStickyATC);
}